import { storeInformationQueries } from "$/hooks/use-store-information"
import { requireOwner } from "$/lib/require-owner"
import { STORE_TYPE } from "@repo/common"
import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/booking-qr-code")({
  loader: async ({ context: { queryClient } }) => {
    await requireOwner(queryClient)

    // Mobile stores have no shop to put the poster up in, so the sidebar
    // hides this for them too.
    const storeInfo = await queryClient.ensureQueryData(
      storeInformationQueries.detail(queryClient),
    )
    const currentStore = storeInfo.stores.find(
      (store) => store.id === storeInfo.storeId,
    )
    if (currentStore?.type === STORE_TYPE.MOBILE) {
      throw redirect({ to: "/", replace: true })
    }

    return {
      crumbs: "alfred.pages.bookingQrCode.crumbs.bookingQrCode",
    }
  },
})
